export default __webpack_public_path__ + "static/media/chromaticwarding.9096c292.png";